import { render, staticRenderFns } from "./ActivityLogger.vue?vue&type=template&id=1684c3f7&scoped=true"
import script from "./ActivityLogger.vue?vue&type=script&lang=js"
export * from "./ActivityLogger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1684c3f7",
  null
  
)

export default component.exports